import { SwitchInput } from '@trueprodigy/components';
import TextInput from '@components/TextInputCaseSetting';
import { isEqual } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import { reduxForm, Field } from 'redux-form/immutable';
import styled from 'styled-components';
import { Button, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import { showError, showSuccess } from '@actions/global';
import { fetchingState } from '@constants';

import SubjectComments from '../../components/subjectDetailForm/subjectComments';
import SubjectDetailHeader from '../../components/subjectDetailForm/subjectDetailHeader';
import {
  Container,
  SubjectDetailFormContainer,
  FieldColumn,
  InfoBlock,
  FormGroupTitleContainer,
  FormGroupTitle,
  StyledButton,
} from '../../components/subjectDetailForm/formComponents';

import * as arbitratorActions from '../../actions/arbitrator';
import selector from './selector';
import './index.scss';
import { canEditSubject } from '@config/permissions/Can';

const styles = {
  appBar: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontWeight: 500,
    backgroundColor: '#efefef',
    boxShadow: 'none',
    '& .MuiTabs-indicator': {
      backgroundColor: '#384698',
    },
    '& .MuiTab-wrapper': {
      letterSpacing: '1.25px',
    },
    '& .Mui-selected': {
      color: '#384698',
    },
  },
};

class ArbitratorDetail extends Component {
  static propTypes = {
    classes: PropTypes.object,
    destroy: PropTypes.func.isRequired,
    setSelectedArbitrator: PropTypes.func,
    changeActiveTab: PropTypes.func,
    addArbitratorNote: PropTypes.func.isRequired,
    arbitrator: ImmutablePropTypes.map,
    createArbitrator: PropTypes.func.isRequired,
    deleteArbitratorNote: PropTypes.func.isRequired,
    dirty: PropTypes.bool,
    fetchArbitrator: PropTypes.func.isRequired,
    fetchArbitratorNotes: PropTypes.func.isRequired,
    formValues: PropTypes.any,
    handleSubmit: PropTypes.func.isRequired,
    history: PropTypes.object,
    initialize: PropTypes.func.isRequired,
    isReadOnly: PropTypes.any,
    match: PropTypes.object,
    notes: PropTypes.object,
    propertiesByName: PropTypes.object,
    resetArbitratorData: PropTypes.func.isRequired,
    updateArbitrator: PropTypes.func.isRequired,
    updateArbitratorNote: PropTypes.func.isRequired,
    deleteArbitrator: PropTypes.func.isRequired,
    validateArbitrator: PropTypes.func.isRequired,
    showSuccess: PropTypes.func,
    showError: PropTypes.func,
    type: PropTypes.string,
    onClose: PropTypes.func,
    userStatus: PropTypes.any,
    setActiveArbitrator: PropTypes.func.isRequired,
    embeddedView: PropTypes.bool,
    viewOnly: PropTypes.any,
  };

  constructor(props) {
    super(props);
    const { match, resetArbitratorData, destroy } = this.props;
    this.isNew = isNaN(match.params.arbitratorID);
    this.state = {
      note: '',
      isNew: this.isNew,
      value: 0,
    };
    if (this.isNew) {
      destroy();
      resetArbitratorData();
    }
  }

  componentDidMount() {
    const {
      fetchArbitrator,
      fetchArbitratorNotes,
      /* fetchArbitratorProperties, */
      match,
      setActiveArbitrator,
    } = this.props;
    const { isNew } = this.state;
    if (!isNew) {
      setActiveArbitrator(match.params.arbitratorID);
      fetchArbitrator({
        arbitratorID: match.params.arbitratorID,
      });
      fetchArbitratorNotes({
        arbitratorID: match.params.arbitratorID,
      });
      /* fetchArbitratorProperties({
        arbitratorID: match.params.arbitratorID,
      }); */
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      arbitrator,
      initialize,
      match,
      resetArbitratorData,
      destroy,
    } = this.props;
    if (
      !isEqual(arbitrator, nextProps.arbitrator) &&
      nextProps.arbitrator.get('data') &&
      nextProps.arbitrator.get('data') !== arbitrator.get('data')
    ) {
      const data = nextProps.arbitrator.get('data').toJS();
      data.autoCass = data.autoCass || false;

      initialize({
        ...data,
      });
    } else if (
      !isEqual(arbitrator, nextProps.arbitrator) &&
      !nextProps.arbitrator.get('data')
    ) {
      // initialize({});
    }
    if (match.params.arbitratorID !== nextProps.match.params.arbitratorID) {
      if (!nextProps.match.params.arbitratorID) {
        this.setState({ isNew: true });
        resetArbitratorData();
        destroy();
      }
    }
  }

  redirectTo(link) {
    const { history } = this.props;
    history.push(link);
  }

  addNote() {
    const { addArbitratorNote, match } = this.props;
    const { note } = this.state;
    if (!note) {
      return;
    }
    addArbitratorNote({
      agentId: match.params.arbitratorID,
      data: {
        content: note,
      },
    });
    this.setState({ note: '' });
  }

  validate() {
    const { formValues, validateArbitrator, match } = this.props;
    if (!formValues) {
      return;
    }
    const formData = formValues.get('values').toJS();
    validateArbitrator({
      arbitratorID: match.params.arbitratorID,
      data: {
        addrStreet1: formData.addrStreet1,
        addrCity: formData.addrCity,
        addrState: formData.addrState,
        lastUpdate: formData.updateDt,
      },
    });
  }

  onChangeNote(note) {
    this.setState({
      note,
    });
  }

  async onDelete() {
    const { match, deleteArbitrator } = this.props;

    deleteArbitrator({
      arbitratorID: parseInt(match.params.arbitratorID),
    }).then(() => {
      this.redirectTo('/litigation/arbitrator-search');
    });
  }

  async onSave() {
    const {
      formValues,
      updateArbitrator,
      createArbitrator,
      match,
      showSuccess,
      setSelectedArbitrator,
      fetchArbitratorNotes,
      arbitrator,
      type,
      onClose,
    } = this.props;
    const { isNew } = this.state;
    if (!formValues) {
      return;
    }
    const formData = formValues.get('values').toJS();
    const arbitratorJS = arbitrator.get('data')
      ? arbitrator.get('data').toJS()
      : {};
    const arbitratorID = match.params.arbitratorID || arbitratorJS.arbitratorID;

    if (isNew) {
      const { results } = await createArbitrator({
        data: {
          ...formData,
          createDt: undefined,
          createdBy: undefined,
          updateDt: undefined,
          updatedBy: undefined,
          arbitratorID: undefined,
          lastUpdate: formData.updateDt,
        },
      });
      showSuccess('Arbitrator created');
      this.setState({
        isNew: !results && !results[0] && !results[0].arbitratorID,
      });
      await fetchArbitratorNotes({
        arbitratorID: results[0].arbitratorID,
      });
      if (setSelectedArbitrator) {
        await setSelectedArbitrator(results[0]);
      }
      if (type === 'select') {
        onClose();
      }
    } else {
      let payload = {
        arbitratorID,
        data: {
          ...formData,
          createDt: undefined,
          createdBy: undefined,
          updateDt: undefined,
          updatedBy: undefined,
          arbitratorID: undefined,
          lastUpdate: formData.updateDt,
        },
      };
      console.log(payload);
      updateArbitrator(payload);
    }
  }

  renderUpdateDate(data) {
    if (data.updateDt || data.updatedBy) {
      let result = 'Updated ';
      if (data.updateDt) {
        result += `on ${moment(data.updateDt).format('YYYY-MM-DD')} at ${moment(
          data.updateDt,
        ).format('h:mm:ss a')} `;
      }
      if (data.updatedBy) {
        result += data.updatedBy;
      }
      return result;
    }
    return null;
  }

  render() {
    const {
      match,
      arbitrator,
      history,
      formValues,
      addArbitratorNote,
      updateArbitratorNote,
      deleteArbitratorNote,
      notes,
      onClose,
      userStatus,
      viewOnly,
    } = this.props;
    const isReadOnly = userStatus.get('readOnly');
    const { isNew } = this.state;
    const arbitratorJS = arbitrator.get('data')
      ? arbitrator.get('data').toJS()
      : {};
    const arbitratorID = match.params.arbitratorID || arbitratorJS.arbitratorID;

    return (
      <Container>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          style={{ padding: '7px 10px', backgroundColor: '#efefef' }}
        >
          <Link
            onClick={() => {
              history.push('/litigation/arbitrator-search');
            }}
          >
            Arbitrator List
          </Link>
          <Typography color="textPrimary">
            {isNaN(arbitratorID) ? 'NEW' : arbitratorID}
          </Typography>
        </Breadcrumbs>
        {(isNew ||
          (arbitrator.get('state') &&
            arbitrator.get('state') !== fetchingState.FETCHING)) && (
          <SubjectDetailHeader
            isNew={isNew}
            name={arbitrator.getIn(['data', 'companyName']) || ''}
            subjectId={isNaN(arbitratorID) ? 'NEW' : parseInt(arbitratorID)}
            subjectType="Arbitrator"
            onClose={() => {
              if (!onClose) return;
              onClose();
            }}
          />
        )}
        {!isNew && arbitrator.get('state') === fetchingState.FETCHING && (
          <CircularProgress />
        )}
        {(isNew ||
          (arbitrator.get('state') &&
            arbitrator.get('state') !== fetchingState.FETCHING)) && (
          <Fragment>
            <SubjectDetailFormContainer>
              <FieldColumn style={{ paddingBottom: 0 }}>
                <Field
                  component={TextInput}
                  disabled={isReadOnly}
                  label="Company Name"
                  name="companyName"
                  placeholder="Company Name"
                  type="text"
                />
                <Field
                  component={TextInput}
                  disabled={isReadOnly}
                  label="First Name"
                  name="firstName"
                  placeholder="First Name"
                  type="text"
                />
                <Field
                  component={TextInput}
                  disabled={isReadOnly}
                  label="Last Name"
                  name="lastName"
                  placeholder="Last Name"
                  type="text"
                />
              </FieldColumn>
              <FieldColumn style={{ paddingBottom: 0 }}>
                <Field
                  component={TextInput}
                  disabled={isReadOnly}
                  label="Contact Name"
                  name="contactName"
                  placeholder="Contact Name"
                  type="text"
                />
                <Field
                  component={TextInput}
                  disabled={isReadOnly}
                  label="Contact Phone"
                  name="contactPhone"
                  placeholder="Contact Phone"
                  type="text"
                />
              </FieldColumn>
              <div style={{ width: '50%' }}>
                <div style={{ display: 'flex' }}>
                  <FieldColumn padding="10px 20px" width="50%">
                    <Field
                      component={SwitchInput}
                      disabled={isReadOnly}
                      label="Free Form Address"
                      name="addrFreeForm"
                    />
                  </FieldColumn>
                  <FieldColumn padding="10px 20px" width="50%">
                    <Field
                      component={SwitchInput}
                      disabled={isReadOnly}
                      label="Inactive"
                      name="inactive"
                    />
                  </FieldColumn>
                </div>
                <div style={{ display: 'flex' }}>
                  {formValues &&
                  formValues.getIn(['values', 'addrFreeForm']) ? (
                    <FieldColumn padding="0px 20px 0px 20px" width="100%">
                      <Field
                        component={TextInput}
                        disabled={isReadOnly}
                        label="Line 1"
                        name="addrFreeForm1"
                        placeholder="Line 1"
                        type="text"
                      />
                      <Field
                        component={TextInput}
                        disabled={isReadOnly}
                        label="Line 2"
                        name="addrFreeForm2"
                        placeholder="Line 2"
                        type="text"
                      />
                      <Field
                        component={TextInput}
                        disabled={isReadOnly}
                        label="Line 3"
                        name="addrFreeForm3"
                        placeholder="Line 3"
                        type="text"
                      />
                    </FieldColumn>
                  ) : (
                    <Fragment>
                      <FieldColumn padding="0px 20px 0px 20px" width="50%">
                        <Field
                          component={TextInput}
                          disabled={isReadOnly}
                          label="Suite/Apt"
                          name="addrUnitDesignator"
                          placeholder="Suite/Apt"
                          type="text"
                        />
                        <Field
                          component={TextInput}
                          disabled={isReadOnly}
                          label="Delivery Address"
                          name="addrDeliveryLine"
                          placeholder="Delivery Address"
                          type="text"
                        />
                        <Field
                          component={TextInput}
                          disabled={isReadOnly}
                          label="City/Township"
                          name="addrCity"
                          placeholder="City/Township"
                          type="text"
                        />
                      </FieldColumn>
                      <FieldColumn padding="0px 20px 0px 20px" width="50%">
                        <Field
                          component={TextInput}
                          disabled={isReadOnly}
                          label="State/Province/Region"
                          name="addrState"
                          placeholder="State/Province/Region"
                          type="text"
                        />
                        <Field
                          component={TextInput}
                          disabled={isReadOnly}
                          label="Country"
                          name="addrCountry"
                          placeholder="Country"
                          type="text"
                        />
                        <Field
                          component={TextInput}
                          disabled={isReadOnly}
                          label="Zip"
                          name="addrZip"
                          placeholder="Zip"
                          type="text"
                        />
                      </FieldColumn>
                    </Fragment>
                  )}
                </div>
              </div>
            </SubjectDetailFormContainer>
            <SubjectDetailFormContainer>
              <InfoBlock width="50%">
                <FormGroupTitleContainer>
                  <FormGroupTitle>ELECTRONIC INFORMATION</FormGroupTitle>
                </FormGroupTitleContainer>
                <Field
                  component={TextInput}
                  disabled={isReadOnly}
                  label="Email Address"
                  name="emailAddress"
                  placeholder="Email Address"
                  type="text"
                />
                <Field
                  component={TextInput}
                  disabled={isReadOnly}
                  label="Web URL"
                  name="webURL"
                  placeholder="Web URL"
                  type="text"
                />
                <Field
                  component={TextInput}
                  disabled={isReadOnly}
                  label="FTP Address"
                  name="ftpAddress"
                  placeholder="FTP Address"
                  type="text"
                />
              </InfoBlock>
              <InfoBlock width="50%">
                <FormGroupTitleContainer>
                  <FormGroupTitle>CASS FOR USPS</FormGroupTitle>
                </FormGroupTitleContainer>
                <div className="flex-container switch-container">
                  Auto Validate
                  <Field
                    disabled={!canEditSubject('AppraisalAgent') || isReadOnly || viewOnly}
                    component={SwitchInput}
                    name="autoCass"
                  />
                </div>
                {!isNew && (
                  <div>
                    <p>
                      CASS Address Validated on:{' '}
                      <span>
                        {arbitrator.getIn(['data', 'cassValidationDt'])}
                      </span>
                    </p>
                  </div>
                )}
              </InfoBlock>
              {/* {!isNew &&
              <div className='input-container'>
                <button className='btn btn-green btn-ghost' disabled={dirty} onClick={() => this.validate()}>Validate Now</button>
              </div>
              } */}
            </SubjectDetailFormContainer>
            <ButtonContainer>
              {!isNew && (
                <Button
                  color="default"
                  variant="contained"
                  disabled={
                    arbitrator.get('state') === fetchingState.SAVING ||
                    /* !canEditSubject('LitigationArbitrator') || */
                    isReadOnly
                  }
                  style={{ marginRight: 8 }}
                  onClick={() => this.onDelete()}
                >
                  Delete
                </Button>
              )}
              <StyledButton
                disabled={
                  arbitrator.get('state') === fetchingState.SAVING ||
                  /* !canEditSubject('LitigationArbitrator') || */
                  isReadOnly
                }
                onClick={() => this.onSave()}
              >
                Save
              </StyledButton>
            </ButtonContainer>
            {!isNew && (
              <SubjectComments
                addNote={!isReadOnly ? addArbitratorNote : null}
                deleteNote={!isReadOnly ? deleteArbitratorNote : null}
                notes={notes}
                subjectId={parseInt(arbitratorID)}
                subjectType={'Arbitrator'}
                updateNote={!isReadOnly ? updateArbitratorNote : null}
                disabled={isReadOnly}
              />
            )}
          </Fragment>
        )}
      </Container>
    );
  }
}

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 10px;
`;

/* const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`; */

const mapDispatchToProps = dispatch => ({
  addArbitratorNote: bindActionCreators(
    arbitratorActions.addArbitratorNote,
    dispatch,
  ),
  deleteArbitratorNote: bindActionCreators(
    arbitratorActions.deleteArbitratorNote,
    dispatch,
  ),
  fetchArbitrator: bindActionCreators(
    arbitratorActions.fetchArbitrator,
    dispatch,
  ),
  fetchArbitratorNotes: bindActionCreators(
    arbitratorActions.fetchArbitratorNotes,
    dispatch,
  ),
  /* fetchAgentProperties: bindActionCreators(
    arbitratorActions.fetchArbiratorProperties,
    dispatch,
  ), */
  validateArbitrator: bindActionCreators(
    arbitratorActions.validateArbitrator,
    dispatch,
  ),
  updateArbitrator: bindActionCreators(
    arbitratorActions.updateArbitrator,
    dispatch,
  ),
  deleteArbitrator: bindActionCreators(
    arbitratorActions.deleteArbitrator,
    dispatch,
  ),
  createArbitrator: bindActionCreators(
    arbitratorActions.createArbitrator,
    dispatch,
  ),
  setActiveArbitrator: bindActionCreators(
    arbitratorActions.setActiveArbitrator,
    dispatch,
  ),
  updateArbitratorNote: bindActionCreators(
    arbitratorActions.updateArbitratorNote,
    dispatch,
  ),
  resetArbitratorData: bindActionCreators(
    arbitratorActions.resetArbitratorData,
    dispatch,
  ),
  showSuccess: bindActionCreators(showSuccess, dispatch),
  showError: bindActionCreators(showError, dispatch),
});

const enhance = compose(
  withStyles(styles),
  withRouter,
  connect(
    selector,
    mapDispatchToProps,
  ),
  reduxForm({
    form: 'litigationArbitratorDetail',
    destroyOnUnmount: true,
  }),
);

export default enhance(ArbitratorDetail);
